import {ReferenceDefinitionDto} from "../../../../../common/apis/stereotype/ReferenceDefinitionDto";
import {LayoutContainer} from "./model/LayoutContainer";
import {AttributeDefinitionDto} from "../../../../../common/apis/stereotype/AttributeDefinitionDto";
import {StereotypeDto} from "../../../../../common/apis/stereotype/StereotypeDto";
import {StereotypeLayoutGenerator} from "./StereotypeLayoutGenerator";
import {GridItem, GridLayoutContainer} from "./model/GridLayoutContainer";
import {UiField} from "./model/UiField";
import {UiFieldFactory} from "./UiFieldFactory";
import {UUIDUtils} from "../../../../../common/UUIDUtils";
import {UiReferenceFieldFactory} from "./UiReferenceFieldFactory";

export class SimpleStereotypeLayoutGenerator implements StereotypeLayoutGenerator {

    private readonly uiFieldFactory: UiFieldFactory = new UiFieldFactory();
    private readonly uiReferenceFieldFactory: UiReferenceFieldFactory = new UiReferenceFieldFactory();

    generateLayout(stereotype: StereotypeDto, attributeDefinitions: AttributeDefinitionDto[], referenceDefinitions: ReferenceDefinitionDto[]): LayoutContainer {
        const gridContainer: GridLayoutContainer = {
            id: UUIDUtils.randomUUID(),
            componentType: "GridLayoutContainer",
            items: []
        };

        const attributeItems = attributeDefinitions.map(attributeDefinition => this.generateGridItemForAttribute(attributeDefinition));
        const referenceItems = referenceDefinitions.map(referenceDefinition => this.generateGridItemForReference(referenceDefinition));
        gridContainer.items = [...attributeItems, ...referenceItems];

        return gridContainer;
    }

    private generateGridItemForAttribute(attributeDefinition: AttributeDefinitionDto): GridItem {
        const uiField = this.generateUiField(attributeDefinition);
        return {
            id: UUIDUtils.randomUUID(),
            componentType: "GridItem",
            gridProperties: {
                xs: 12,
                md: 6
            },
            childComponents: [uiField]
        };
    }

    private generateUiField(attributeDefinition: AttributeDefinitionDto): UiField {
        return this.uiFieldFactory.buildUiField(attributeDefinition);
    }

    private generateGridItemForReference(referenceDefinition: ReferenceDefinitionDto): GridItem {
        const uiReferenceField = this.generateUiReferenceField(referenceDefinition);
        return {
            id: UUIDUtils.randomUUID(),
            componentType: "GridItem",
            gridProperties: {
                xs: 12,
                md: 6
            },
            childComponents: [uiReferenceField]
        };
    }

    private generateUiReferenceField(referenceDefinition: ReferenceDefinitionDto): UiField {
        return this.uiReferenceFieldFactory.buildUiReferenceField(referenceDefinition);
    }

}